import React, { useEffect, useRef, useState } from "react";
import { Box, useTheme, Typography } from "@mui/material";
import * as signalR from "@microsoft/signalr";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import avatar from "../../../asset/imgs/avatars/2.png";
import { useAuth } from "../../../Context/AuthProvider";
import ProfileSetting from "../ProfileSetting";
import { baseApiUrl } from "../../../env";
import { useGetAllNotification } from "../Hooks";
import ToastCustomise from "../../../General/Components/ToastCustomise/ToastCustomise";
import { useGetLogout } from "../../../Components/Login/Hooks";
import AppLogo from "./AppLogo";
import Notifcation from "./Notifcation";
import AppBarAnnouncement from "./AppBarAnnouncement";
import useDeviceType from "../Hooks/useDeviceType";
import MobileNavgation from "./components/MobileNavgation";
import useModuleMenu from "./hooks/useModuleMenu";
import ModuleMenu from "./components/ModuleMenu";
import UserProfileMobile from "./components/UserProfileMobile";
import SwitchTheme from "./components/SwitchTheme";
import { useDashboardSettings } from "../../../Context/DashboardSettingProvider";
import { deleteSetting } from "../../../utils/Db";
import AppSetting from "../../../General/AppSetting/AppSetting";

const NOTIFICATION_SOUND_URL = "/mixkit-confirmation-tone-2867.wav";

const MainAppBar = () => {
  const theme = useTheme();
  const deviceType = useDeviceType();

  const date = new DateObject({ calendar: persian, locale: persian_fa });
  const now = date.format("dddd DD MMMM");

  /**==============================================
   *                User Config
   *=============================================**/
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);
  const handleClick = (event) => setAnchorEl(event.currentTarget);

  // یک‌بار خونده می‌شه و همه‌جا از همین استفاده می‌کنیم
  const [userInfo] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userInfo")) ?? null;
    } catch {
      return null;
    }
  });
  const userLogin = userInfo?.userLogin;
  const userImageUr = userInfo?.userImageUr;

  const [settingModal, setSettingModal] = useState(false);

  /**----------------------
   *    Log out
   *------------------------**/
  const newOpr = useAuth();
  const { mutate } = useGetLogout();
  const logOutHandler = () => {
    newOpr.logout();
    mutate();
  };

  /*================================ Get All Notification Messages ==============================*/
  const { data, refetch } = useGetAllNotification(userInfo?.userId);
  const TotalMessage = data ? data.length : 0;
  const [openToast, setOpenToast] = useState(null);
  const [toastText, setToastText] = useState([]);
  const [colorToas, setColorToast] = useState("");

  const audioRef = useRef(null);
  if (!audioRef.current) {
    audioRef.current = new Audio(NOTIFICATION_SOUND_URL);
  }

  const handleSuccess = () => {
    setToastText((prev) => [
      ...prev,
      {
        text: (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <i style={{ color: "black" }} className="icon-Letter"></i>
            <span style={{ color: "black", padding: "0 6px" }}>
              یک پیام جدید دارید
            </span>
          </Box>
        ),
      },
    ]);
    setOpenToast(true);
    setColorToast("#F1F8F1");
  };

  /*================================ Notification SignalR ==============================*/
  // نگه‌داشتن آخرین مقادیر برای جلوگیری از stale closure داخل هندلر SignalR
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;
  const userIdRef = useRef(userInfo?.userId);
  userIdRef.current = userInfo?.userId;

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseApiUrl}/SignalRHub`)
      .withAutomaticReconnect()
      .build();

    connection.on("NotificationRefresh", (userId) => {
      if (userId === userIdRef.current) {
        refetchRef.current?.();
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => { });
        handleSuccess();
      }
    });

    connection.start().catch((err) => {
      console.error("SignalR connection failed:", err);
    });

    return () => {
      connection.stop().catch((err) => {
        console.error("SignalR disconnect failed:", err);
      });
    };
  }, []);

  /*================================ module Menu  ==============================*/
  const { showModuleMenu, toggleMenuHandler } = useModuleMenu();

  return (
    <>
      {/* /*================================ module Menu Render  ==============================*/}
      <ModuleMenu open={showModuleMenu} toggleMenuHandler={toggleMenuHandler} />

      {/* /*================================ MobileNavgation Render  ==============================*/}
      {deviceType === "mobile" && <MobileNavgation />}

      <Box
        position="sticky"
        display="flex"
        sx={{
          height: { xl: "80px", lg: "100px", md: "200px", xs: "80px" },
          flex: 1,                // ← به‌جای width:"100%"، فقط فضای باقی‌مونده رو بگیره
          justifyContent: { xs: "center" },
          flexDirection: { xs: "column", lg: "row" },
        }}
      >
        <Box
          position="sticky"
          display="flex"
          sx={{
            height: { xl: "80px", lg: "100px", md: "200px", xs: "80px" },
            flex: 1,                // ← به‌جای width:"100%"، فقط فضای باقی‌مونده رو بگیره
            justifyContent: { xs: "center" },
            flexDirection: { xs: "column", lg: "row" },
          }}
        >
          <Box
            minWidth={{ lg: "20%", xs: "100%" }}
            display="flex"
            justifyContent={{ xs: "space-between", lg: "flex-start" }}
            alignItems="center"
            flexGrow={3}
          >
            <AppLogo toggleMenuHandler={toggleMenuHandler} />
            {/* mobile profile */}
            <UserProfileMobile
              userImageUr={userImageUr}
              handleClick={handleClick}
              userLogin={userLogin}
              logOutHandler={logOutHandler}
            />
          </Box>

          {/* Announcement */}
          <Box
            sx={{ display: { xs: "none", md: "flex" } }}
            minWidth={{ xl: "50%", lg: "50%", xs: "100%" }}
            justifyContent={{ xs: "space-between", lg: "flex-start" }}
            alignItems="center"
          >
            <AppBarAnnouncement />
          </Box>

          <Box
            flexGrow={2}
            alignItems="center"
            justifyContent={{ xs: "center", lg: "flex-start" }}
            flexDirection="row-reverse"
            sx={{
              width: "100%",
              flexWrap: "wrap",
              display: { xs: "none", md: "flex" },
            }}
          >
            <div
              className="user-info-box"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div
                className="user-avatar"
                style={{ position: "relative", marginRight: "12px", marginLeft: "12px" }}
              >
                {userImageUr && (
                  <img
                    src={userImageUr || avatar}
                    alt=""
                    className="avatar-menu-bar"
                    onClick={handleClick}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      width: "2.2rem",
                      height: "2.2rem",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </div>

              <Button
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                className="user-profil-btn"
                sx={{ color: theme.palette.mode === "dark" ? "#FAFAFA" : "#000" }}
              >
                {userLogin ? `${userLogin.firstName} ${userLogin.lastName}` : ""}
                <KeyboardArrowDownIcon sx={{ marginLeft: "0.5rem" }} />
              </Button>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ "aria-labelledby": "basic-button" }}
              >
                <MenuItem onClick={() => setSettingModal(true)}>حساب من</MenuItem>
                <MenuItem onClick={logOutHandler}>خروج از حساب کاربری</MenuItem>
              </Menu>
            </div>

            <div className={`icon-baget-border ${theme.palette.mode === "dark" ? "dark" : "light"}`}>
              {/* Notification Icon */}
              <Notifcation data={data} userId={userInfo?.userId} totalMessage={TotalMessage} />
            </div>

            {/* Switch Mode */}
            <SwitchTheme />

            <Typography sx={{ display: { xs: "none", lg: "block" } }} fontSize={"12px"} mr={2}>
              {now}
            </Typography>
          </Box>
        </Box>
        <Box sx={{display:'flex',alignItems:'center',px:1 }}>
        <AppSetting />
        </Box>

      </Box>

      <ProfileSetting settingModal={settingModal} setSettingModal={setSettingModal} />

      {/* /*================================== Return Toast ======================================*/}
      {openToast && (
        <ToastCustomise
          openToast={openToast}
          setOpenToast={setOpenToast}
          text={toastText}
          setToastText={setToastText}
          key={"1"}
          color={colorToas}
          horizontal={"right"}
        />
      )}
    </>
  );
};

export default MainAppBar;
